/**
 * when user call configure bofore run,
 * target module will be pushed to pending modules array,
 * later they all will been configured by run api in startup process
 */
export default [];
